/**
 * Visibility — react to tab background/foreground.
 *
 * When the tab is hidden, we pause locally so the game doesn't drain battery
 * or run inputs against a frozen rAF. When it returns, we ask the host for a
 * fresh state snapshot so we don't try to resume from a stale world.
 */
export class Visibility {
  /**
   * @param {object} opts
   * @param {() => void} opts.onHidden
   * @param {() => void} opts.onVisible
   */
  constructor(opts) {
    this.onHidden = opts.onHidden || (() => {});
    this.onVisible = opts.onVisible || (() => {});
    this._handler = () => {
      if (document.hidden) this.onHidden();
      else this.onVisible();
    };
    document.addEventListener('visibilitychange', this._handler);
  }

  destroy() {
    document.removeEventListener('visibilitychange', this._handler);
  }
}
